import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';

const EnsureForgotPassword = ({ children }) => {
    const { currentUser } = useAuth();

    if (currentUser) {
        return <Navigate to="/dashboard" />; // Redirect logged-in users
    }

    return children; // Render ForgotPassword component for others
};

export default EnsureForgotPassword;